// Türkiye il nüfus verileri (TÜİK 2023 gerçek veriler) - 2D için Point, 3D için Polygon
export const turkeyPopulationData = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "İstanbul",
        "population": 15519267,
        "area": 5461,
        "displayValue": "15.5M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [28.9, 41.0]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Ankara",
        "population": 5663322,
        "area": 25706,
        "displayValue": "5.7M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [32.9, 39.9]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "İzmir",
        "population": 4367251,
        "area": 11811,
        "displayValue": "4.4M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [27.2, 38.4]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Bursa",
        "population": 3087907,
        "area": 10391,
        "displayValue": "3.1M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.1, 40.2]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Antalya",
        "population": 2586508,
        "area": 20177,
        "displayValue": "2.6M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [30.7, 36.9]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Adana",
        "population": 2258718,
        "area": 13844,
        "displayValue": "2.3M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [35.3, 37.0]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Konya",
        "population": 2273834,
        "area": 38257,
        "displayValue": "2.3M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [32.5, 37.9]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Gaziantep",
        "population": 2139802,
        "area": 6207,
        "displayValue": "2.1M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [37.4, 37.1]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Şanlıurfa",
        "population": 2144050,
        "area": 18584,
        "displayValue": "2.1M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [38.8, 37.2]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Kocaeli",
        "population": 1993072,
        "area": 3625,
        "displayValue": "2.0M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.9, 40.8]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Mersin",
        "population": 1856326,
        "area": 15853,
        "displayValue": "1.9M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [34.6, 36.8]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Diyarbakır",
        "population": 1794144,
        "area": 15355,
        "displayValue": "1.8M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [40.2, 37.9]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Hatay",
        "population": 1770123,
        "area": 5403,
        "displayValue": "1.8M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [36.2, 36.4]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Manisa",
        "population": 1443426,
        "area": 13120,
        "displayValue": "1.4M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [27.4, 38.6]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Kayseri",
        "population": 1404373,
        "area": 16917,
        "displayValue": "1.4M"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [35.5, 38.7]
      }
    }
  ]
};

// 3D nüfus verileri için polygon veri seti (Medium #5 makalesi)
export const turkeyPopulation3DData = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "İstanbul",
        "population": 15519267,
        "area": 5461,
        "displayValue": "15.5M"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [28.5, 40.8],
          [29.3, 40.8],
          [29.3, 41.2],
          [28.5, 41.2],
          [28.5, 40.8]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Ankara",
        "population": 5663322,
        "area": 25706,
        "displayValue": "5.7M"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [32.5, 39.7],
          [33.3, 39.7],
          [33.3, 40.1],
          [32.5, 40.1],
          [32.5, 39.7]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "İzmir",
        "population": 4367251,
        "area": 11811,
        "displayValue": "4.4M"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [26.8, 38.2],
          [27.6, 38.2],
          [27.6, 38.6],
          [26.8, 38.6],
          [26.8, 38.2]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Bursa",
        "population": 3087907,
        "area": 10391,
        "displayValue": "3.1M"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [28.7, 40.0],
          [29.5, 40.0],
          [29.5, 40.4],
          [28.7, 40.4],
          [28.7, 40.0]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Antalya",
        "population": 2586508,
        "area": 20177,
        "displayValue": "2.6M"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [30.3, 36.7],
          [31.1, 36.7],
          [31.1, 37.1],
          [30.3, 37.1],
          [30.3, 36.7]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Adana",
        "population": 2258718,
        "area": 13844,
        "displayValue": "2.3M"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [34.9, 36.8],
          [35.7, 36.8],
          [35.7, 37.2],
          [34.9, 37.2],
          [34.9, 36.8]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Konya",
        "population": 2273834,
        "area": 38257,
        "displayValue": "2.3M"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [32.1, 37.7],
          [32.9, 37.7],
          [32.9, 38.1],
          [32.1, 38.1],
          [32.1, 37.7]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Gaziantep",
        "population": 2139802,
        "area": 6207,
        "displayValue": "2.1M"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [37.0, 36.9],
          [37.8, 36.9],
          [37.8, 37.3],
          [37.0, 37.3],
          [37.0, 36.9]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Şanlıurfa",
        "population": 2144050,
        "area": 18584,
        "displayValue": "2.1M"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [38.4, 37.0],
          [39.2, 37.0],
          [39.2, 37.4],
          [38.4, 37.4],
          [38.4, 37.0]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Kocaeli",
        "population": 1993072,
        "area": 3625,
        "displayValue": "2.0M"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.5, 40.6],
          [30.3, 40.6],
          [30.3, 41.0],
          [29.5, 41.0],
          [29.5, 40.6]
        ]]
      }
    }
  ]
};

// Gerçek nehir verileri - OpenStreetMap'ten alınan veriler
export const turkeyRiversData = {
  "type": "FeatureCollection",
  "features": []
};
